import React from 'react';
import { css } from '@emotion/css';
import Card from '@mui/material/Card';
import { colors } from 'styles/colors';

type InfoCardProps = {
    title?: string
    icon?: React.ReactElement
    children?: React.ReactNode
    style?: string
}

const InfoCard = ({ title, icon, children, style }: InfoCardProps) => {
    return (
        <Card sx={{
            border: `1px solid ${colors.primary}`,
            borderTop: `5px solid ${colors.primary}`,
            borderRadius: '2px',
        }} className={`${styles.card} ${style}`}>
            <div className={styles.titleRow}>
                {title && <span className={styles.title}>{title}</span>}
                {icon && React.cloneElement(icon, { className: styles.icon })}
            </div>
            {children}
        </Card>
    );
};

const styles = {
    card: css({
        width: '19rem',
        minHeight: '7.5rem',
        padding: '1.25rem',
        border: `1px solid ${colors.primary}`,
        borderRadius: '0px',
    }),
    titleRow: css({
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    }),
    title: css({
        height: '3rem',
        fontWeight: '400',
        fontSize: '18px',
        lineHeight: '21px',
        marginRight: '0.5rem',
    }),
    icon: css({
        width: '1.35rem',
        height: '1.35rem',
        marginRight: '0.5rem',
    }),
};

export default InfoCard;
